import config from 'config';

import { getStargateBridgeConfig } from '../crossChainMapping';

import { Layer0MessagesJson, Layer0Record } from './layer0Schema';

const fetchLayer0Tx = async (tx: string): Promise<Layer0Record | undefined> => {
  const response: Layer0MessagesJson | undefined = await fetch(
    `https://scan${
      config.envIsSandbox ? '-testnet' : ''
    }.layerzero-api.com/v1/messages/tx/${tx}`
  ).then(response => response.json());
  return response?.data?.[0];
};

/**
 * Get Stargate swap transaction status.
 * API Docs:  https://scan-testnet.layerzero-api.com/v1/swagger
 *
 * Example response:
 *  https://scan-testnet.layerzero-api.com/v1/messages/tx/0x555b1c9f53e312f5407c2f3856908d819477efac7b3cb4a63644ab7381e0bf21
 *
 * There is legacy client but not maintained:
 *  const { createClient } = await import('@layerzerolabs/scan-client');
 *  https://api-testnet.layerzero-scan.com/tx/0x335fcc6f244fdd40ca1d6f11944cbda0c01c6a55e8c69082808b2312c24c96e0
 */
export async function getStargateSwapStatus(
  initiatedTxHash: string,
  forwarderTxHash: string | undefined
) {
  const bridgingData = await fetchLayer0Tx(forwarderTxHash ?? initiatedTxHash);

  if (!bridgingData || !bridgingData.pathway) {
    console.log('No Layer0 data ready for', initiatedTxHash, forwarderTxHash);
    return undefined;
  }
  const pathway = bridgingData.pathway;
  const configJumpChain = getStargateBridgeConfig(
    config.chains.katanaChain.stargateJumpChain
  );
  const isMiddleJump = configJumpChain.layerZeroEndpointId === pathway.dstEid;
  const destination = bridgingData.destination;
  const lzComposeTxHash =
    destination && 'lzCompose' in destination
      ? destination.lzCompose?.txs?.[0]?.txHash
      : undefined;

  return {
    status: bridgingData.status?.name,
    message: bridgingData.status?.message,
    forwarderLzComposeTxHash:
      forwarderTxHash ?? isMiddleJump ? lzComposeTxHash : undefined,
    destinationTxHash: isMiddleJump ? undefined : destination?.tx?.txHash,
    // destinationError: firstMessage?.dstTxError,
  };
}
